"use strict";

exports.__esModule = true;
exports.processTriggerInput = processTriggerInput;
var _evaluateTrigger = require("./evaluateTrigger");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Given a trigger processor state and some input, evaluate the
 * input and return a new state if triggers apply, or the old state if
 * no triggers match.
 */
function processTriggerInput(state, input, time, timezone) {
  var delay = state.delay,
    triggers = state.triggers;
  var results = [];
  var now = Date.now();
  var timeSinceLastAction = now - state.lastActionAt;
  if (timeSinceLastAction < delay) {
    return state;
  }
  for (var _iterator = _createForOfIteratorHelperLoose(triggers), _step; !(_step = _iterator()).done;) {
    var _step$value = _step.value,
      trigger = _step$value[0],
      action = _step$value[1];
    var matches = (0, _evaluateTrigger.evaluateTrigger)(trigger, input, time, timezone);
    if (matches) {
      results.push(action(trigger, input));
    }
  }
  if (results.length === 0) {
    return state;
  }
  var lastActionAt = now;
  return {
    lastActionAt: lastActionAt,
    delay: delay,
    triggers: triggers,
    results: results
  };
}